visa-hero {
  --font-family: "Visa Dialect", sans-serif;
  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
  --media-overlay-dark-bg-color: #000000;
}

.vs-hero-container-theme-light {
  --text-primary: #ffffff;
  --color-text-inverse: #ffffff;
  --button-primary-bg: #1434cb;
  --button-primary-text: #ffffff;
  --button-primary-bg-hover: #0d2181;
  --button-primary-border: none;
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-hero-container-theme-dark {
  --text-primary: #ffffff;
  --color-text-inverse: #ffffff;
  --button-primary-bg: #ffffff;
  --button-primary-text: #1a1a1a;
  --button-primary-bg-hover: #f0f0f0;
  --button-primary-border: none;
  --button-secondary-bg: transparent;
  --button-secondary-text: #ffffff;
  --button-secondary-hover-text: #1a1a1a;
  --button-secondary-bg-hover: #ffffff;
  --button-secondary-border: #ffffff;
}

.vs-hero-container-theme-light,
.vs-hero-container-theme-dark {
  .vs-hero-tint {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--media-overlay-dark-bg-color, #000);
    opacity: 0.3;
    z-index: 1;
  }
  &.no-tint {
    .vs-hero-tint {
      background-color: transparent !important;
    }
  }
}

.vs-hero-container {
  z-index: 1;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 810px;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1024px) {
    height: 700px;
  }
  @media (max-width: 375px) {
    height: 814px;
    &.medium-height {
      height: 610px;
    }
  }

  &.medium-height {
    height: 675px;
  }

  &.video-background {
    background-image: none !important;
  }

  &.authoring-mode {
    height: 700px;
    min-height: 300px;
    overflow: hidden;
    background-size: cover;
    background-position: center;

    .vs-hero-authoring-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
      text-align: center;
      z-index: 10;

      p {
        margin: 5px 0;
        font-size: 16px;
      }
    }
  }

  h1.vs-hero-title {
    display: inline-block;
    font-size: 4rem;
    font-weight: 400;
    line-height: 1;
    letter-spacing: -0.02em;
    margin: 0 24px;
    color: var(--text-primary);
    @media (max-width: 480px) {
      font-size: 2.5rem;
    }
    p {
      padding-bottom: 9px;
    }
  }

  h2.vs-hero-title,
  h3.vs-hero-title,
  h4.vs-hero-title {
    display: inline-block;
    font-size: 2.5rem;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.02em;
    color: var(--text-primary);
    p {
      padding-bottom: 9px;
    }
  }

  .vs-hero-description-bottom {
    position: absolute;
    left: 50%;
    bottom: 74px;
    transform: translateX(-50%);
    width: 100%;
    display: flex;
    justify-content: center;
    pointer-events: none;
    @media (max-width: 1024px) {
      padding: 0 45px;
    }
    .vs-hero-description {
      text-align: center;
      pointer-events: auto;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.4;
      max-width: 414px;
      margin: 0;
      color: var(--color-text-inverse);
      @media (max-width: 1024px) {
        max-width: 448px;
      }
      @media (max-width: 375px) {
        padding: 0 45px;
      }
      p {
        margin: 0;
      }
    }
  }

  .vs-hero-button-group {
    display: flex;
    gap: 8px;
    margin-top: 32px;
    height: 48px;
    align-items: center;

    @media (max-width: 1024px) {
      margin-top: 24px;
    }

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      padding: 0 16px;
      height: auto;

      vsr-button-v2,
      vsr-link-button-v2 {
        width: 100%;
        .button {
          width: 100%;
        }
      }
    }
  }

  .vs-hero-primary-button,
  .vs-hero-secondary-button {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    border-radius: 1000px;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 48px;
    padding: 18.5px 24px;
    min-width: 126px;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    border: none;
  }

  .vs-hero-primary-button {
    background-color: var(--button-primary-bg);
    color: var(--button-primary-text);
    text-decoration: none;

    &:hover {
      text-decoration: none;
      background-color: var(--button-primary-bg-hover);
    }

    &:focus-visible {
      outline: none;
      background-color: var(--button-primary-bg-hover);
    }
  }

  .vs-hero-secondary-button {
    background-color: var(--button-secondary-bg);
    color: var(--button-secondary-text);
    border: 1px solid var(--button-secondary-border);
    text-decoration: none;

    &:hover,
    &:focus-visible {
      outline: none;
      color: var(--button-secondary-hover-text);
      background-color: var(--button-secondary-bg-hover);
    }
  }

  @keyframes vs-hero-bounce {
    0%,
    20%,
    70%,
    80%,
    100% {
      transform: translateY(0) translateX(-50%) scale(1);
    }
    50% {
      transform: translateY(-10px) translateX(-50%) scale(0.9);
    }
  }

  button.vs-hero-moving-arrow {
    background: none;
    outline: none;
    border: none;
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    animation: vs-hero-bounce 2.5s ease-in-out infinite;
    z-index: 2;
  }

  button.vs-hero-moving-arrow:focus-visible {
    outline: 2px solid #1434cb;
    outline-offset: 2px;
  }

  button.vs-hero-moving-arrow svg:focus,
  button.vs-hero-moving-arrow svg:focus-visible {
    outline: 2px solid #1434cb;
    outline-offset: 2px;
  }

  button.vs-hero-moving-arrow {
    color: var(--color-text-inverse);
  }
}
.vs-hero-container.is-top-of-page {
  padding-top: 73px;
}
.vs-hero-container.has-bg-image-video::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image: var(--hero-bg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.5);
  animation: heroBgZoomOut 1.4s cubic-bezier(0.83, 0.01, 0.18, 1) forwards;
}

@keyframes heroBgZoomOut {
  to {
    transform: scale(1);
  }
}

.vs-hero-content-wrapper,
.vs-hero-description-bottom,
.vs-hero-moving-arrow {
  position: relative;
  z-index: 1;
}

.vs-hero-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

  // Ensure video covers the entire container
  min-width: 100%;
  min-height: 100%;

  // Hide video controls
  &::-webkit-media-controls {
    display: none !important;
  }

  &::-webkit-media-controls-panel {
    display: none !important;
  }

  &::-webkit-media-controls-play-button {
    display: none !important;
  }

  &::-webkit-media-controls-start-playback-button {
    display: none !important;
  }

  cursor: default;

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
  }
}

// Fallback for when video fails to load
.vs-hero-container.video-background:not(.video-loaded) {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.vs-hero-content-wrapper {
  position: relative;
  z-index: 2;
  max-width: 882px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 141px; /* Default margin for 100% height on screens >= 768px */

  /* For 100% height on screens < 768px */
  @media (max-width: 767px) {
    margin-bottom: 135px;
  }

  /* For 75% height (medium-height) on screens >= 768px */
  .medium-height & {
    margin-bottom: 197px;

    /* For 75% height on screens < 768px */
    @media (max-width: 767px) {
      margin-bottom: 61px;
    }
  }

  @media (max-width: 1024px) {
    max-width: 605px;
  }
  @media (max-width: 375px) {
    max-width: 327px;
  }
}

.vs-hero-copy-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@keyframes customSlideButtonInUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  15%,
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes customFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// Reduced motion support
@media (prefers-reduced-motion: reduce) {
  .vs-hero-video {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }

  .vs-hero-moving-arrow {
    animation: none;
  }
}

// High contrast mode support
@media (prefers-contrast: high) {
}

// Portrait mode adjustments for mobile
@media (max-width: 768px) and (orientation: portrait) {
  .vs-hero-container {
    justify-content: flex-start;
  }
}

// Landscape mode adjustments for mobile
@media (max-height: 500px) and (orientation: landscape) {
}
